export default "__VITE_ASSET__ca5T8H82__"